'use client';

export default function MicrositeUSP({ block, position }) {
  const { item: itemList, uid } = block.microsite_usp.reference[0];

  return (
    <section id={`${uid}_${position}`} data-name="microsite-usp">
      <div className="mb-6 flex items-center">
        {itemList.map((item, index) => {
          return (
            <div key={index} className="flex items-center">
              <div className="body-s text-dawn-grey-60 whitespace-nowrap">
                {item.title}
              </div>
              {index < itemList.length - 1 && (
                <span className="text-dawn-grey-60 mx-2">•</span>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
